import { API_PROFILE_AVATAR_UPDATE } from '@/constant/apiRout';
import axios from '@/lib/axios';
import React, { useRef, useState } from 'react';
import { CiCirclePlus, CiEdit } from 'react-icons/ci';
import { FiEdit } from 'react-icons/fi';
import { ImCancelCircle } from 'react-icons/im';
import { toast } from 'react-toastify';

interface ProfileImageUploadProps {
  image?: string; // default image URL from props
  selectedFile: File | null;
  setSelectedFile: any;
}

const ProfileImageUpload: React.FC<ProfileImageUploadProps> = ({
  image,
  selectedFile,
  setSelectedFile,
}) => {
  const [selectedImage, setSelectedImage] = useState<string | null>(
    image || null
  );

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  // Handle file selection & preview
  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      setSelectedFile(file);

      // Show preview immediately
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result as string);
      };
      reader.readAsDataURL(file);

      // ---- Upload immediately ----
      try {
        const formData = new FormData();
        formData.append('image', file);
        formData.append('filename', file.name);

        const res = await axios.post(API_PROFILE_AVATAR_UPDATE, formData);

        if (res.data.result) {
          toast.success('Profile image updated successfully');
        } else {
          toast.error(res.data.message || 'Image upload failed');
        }
      } catch (error: any) {
        toast.error('Error uploading image');
      }
    }
  };

  return (
    <div className="text-center position-relative">
      {/* Clickable Round Image */}
      <div
        className="rounded-circle border d-flex align-items-center justify-content-center overflow-hidden mx-auto"
        style={{
          width: '130px',
          height: '130px',
          cursor: 'pointer',
          position: 'relative',
        }}
        onClick={() => fileInputRef.current?.click()}
      >
        {selectedImage ? (
          <img
            src={selectedImage}
            alt="Profile"
            className="w-100 h-100"
            style={{ objectFit: 'cover' }}
            onError={(e) => {
              (e.target as HTMLImageElement).src =
                '/images/icon/demo-person.jpg';
            }}
          />
        ) : (
          <img
            src="/images/icon/demo-person.jpg" // fallback if no props & no uploaded image
            alt="Profile"
            className="w-100 h-100"
            style={{ objectFit: 'contain' }}
          />
        )}
      </div>

      <FiEdit
        className="position-absolute"
        style={{
          right: 'calc(50% - 60px)',
          bottom: '10px',
          cursor: 'pointer',
          fontSize: '20px',
          color: 'black',
        }}
        onClick={() => fileInputRef.current?.click()}
      />

      {/* Hidden File Input */}
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        className="d-none"
        onChange={handleImageChange}
      />
    </div>
  );
};

export default ProfileImageUpload;
